import {UserStripeService} from "../../../stripe/service/UserStripeService";
import {StoreProductStates} from "../../common/models/StoreProductState";
import {StripeProductName} from "../../../stripe/models/StripeProductNames";
import {StoreService} from "../../common/services/StoreService";
import {IHttpService} from "angular";
import {IInvestProductMappings, IInvestStoreProduct} from "../models/IInvestStoreProduct";

export class IInvestStoreService extends StoreService<IInvestStoreProduct> {

    public static id = "iinvestStoreService";

    protected updateUrl = "/tradefloor/api/store/iinvest/subscriptions";

    /** @ngInject */
    public constructor($http: IHttpService, userStripeService: UserStripeService) {
        super($http, userStripeService);
    }

    public async currentProductState(): Promise<StoreProductStates<IInvestStoreProduct>> {
        const [history, subscriptions] = await this.userDetails();
        const platformHistory = history.historyFor(StripeProductName.PLATFORM);
        const hasPlatformSubscription = this.hasSubscriptionFor(subscriptions, IInvestProductMappings.PLATFORM.stripeProducts);
        const platform = this.productState(hasPlatformSubscription, platformHistory);
        return {
            PLATFORM: platform
        };
    }
}
